export default __webpack_public_path__ + "static/media/roboto-condensed-v19-latin-700.114cd18b.woff2";